import { PLAY_INFO_ID, SenderType } from '@/const/mission';
import { IEvents } from '@/interface';


// 填充剧情角色
export const getDefaultBotEvent = (
  botEvent: IEvents,
  botList: {
    id: string;
    name: string;
  }[],
) => {
  if (botEvent?.message?.sender?.type === SenderType.BOT && !botEvent?.message?.sender?.senderId) {
    return {
      ...botEvent,
      message: {
        ...botEvent?.message,
        sender: {
          type: botList?.[0]?.id === PLAY_INFO_ID ? SenderType.USER : SenderType.BOT,
          senderId: botList?.[0]?.id || '',
        },
      },
    };
  }
  return botEvent;
};
